module.exports = __webpack_public_path__ + "components/flag/static/square/br-be3685d3df504822ee73d7401e0bd8dc.svg";